import axios from './index'

/**
 * Klient modułów e-ZLA i NFZ. Reguły ZUS i NFZ liczy medapi — EHR tylko pyta.
 * Trasa `/api/auth/*` jest proxy po stronie serwera EHR, żeby klucz do medapi
 * nie trafił do przeglądarki.
 *
 * Hasło do certyfikatu podaje lekarz przy każdym podpisie i nigdzie go nie
 * przechowujemy: ani w stanie aplikacji po wysłaniu, ani w pamięci sesji.
 */
export default {
  /** Projekt zwolnienia. Nic nie wysyła do ZUS. */
  draft(payload) {
    return axios.post('/api/auth/ezla/draft', payload)
  },

  /**
   * Wystawia zwolnienie w ZUS. Odpowiedź 409 znaczy „ZUS zna podobne ZLA
   * tego pacjenta" i niesie ich listę — wtedy trzeba powtórzyć z
   * `pomimo_podobnych: true`, ale dopiero po decyzji lekarza.
   */
  wystaw(payload) {
    return axios.post('/api/auth/ezla/wystaw', payload)
  },

  /** Anulowanie wystawionego zwolnienia (dokument AZLA). */
  anuluj(payload) {
    return axios.post('/api/auth/ezla/anuluj', payload)
  },

  /** Stan puli numerów; z polem `ile` rezerwuje nowe. */
  pula(payload) {
    return axios.post('/api/auth/ezla/pula', payload)
  },

  /** Słowniki ZUS — dziś przyczyny anulowania. */
  slowniki(payload) {
    return axios.post('/api/auth/ezla/slowniki', payload)
  },

  /**
   * Wydruk zwolnienia dla pacjenta (PDF) albo poświadczenie z ZUS (XML).
   * Przychodzi jako blob i od razu idzie do przeglądarki — nie przechodzi
   * przez stan aplikacji, żeby dokument z danymi pacjenta nie został w pamięci.
   */
  wydruk(payload) {
    return axios.post('/api/auth/ezla/wydruk', payload, { responseType: 'blob' })
  },

  /** Stan gałęzi NFZ tenanta. */
  nfzStan() {
    return axios.get('/api/auth/nfz/stan')
  },

  /** Spalanie kontraktu NFZ. */
  nfzPule() {
    return axios.get('/api/auth/nfz/pule')
  }
}
